/**
 * The function that actually loads the entry points of each different bundle,
 * almost always of the form src/{bundleName}/main.js.
 *
 * This function was separated out into its own file so that files could
 * require Bundles.js without being forced to import all of BA's clientside JS.
 * See the documentation of injectLoadBundle in Bundles.js for more details.
 *
 * This is the only bit of code in BA's src folder that should use
 * require.ensure calls, which is webpack syntax.
 *
 * @param bundleName {string} Name of the bundle, usually an src subfolder.
 * @param onSuccess {function} Callback if the bundle loading succeeds. It is
 *   passed the export of the bundle's entry point as its only argument.
 * @param onError {function} Callback if the bundle loading fails. It is passed
 *   an error object as its only argument.
 */
const loadBundle = function(bundleName, onSuccess, onError) {
	// Because webpack looks for require.ensure in static analysis, we have to
	// write out an if clause for each bundle.
	if (process.env.IS_NODE) {
		// webpack uses the above to avoid require.ensure in its static analysis.
	} else if (bundleName === "trainer") {
		require.ensure(
			["../trainer/main.js"],
			function(require) {
				try {
					const bundleExports = require("../trainer/main");
					onSuccess(bundleExports);
				} catch (ex) {
					onError(ex);
				}
			},
			onError,
			"trainer"
		);
	} else if (bundleName === "office") {
		require.ensure(
			["../office/main.js"],
			function(require) {
				try {
					const bundleExports = require("../office/main");
					onSuccess(bundleExports);
				} catch (ex) {
					onError(ex);
				}
			},
			onError,
			"office"
		);
	} else if (bundleName === "parent") {
		require.ensure(
			["../parent/main.js"],
			function(require) {
				try {
					const bundleExports = require("../parent/main");
					onSuccess(bundleExports);
				} catch (ex) {
					onError(ex);
				}
			},
			onError,
			"parent"
		);
	} else if (bundleName === "school") {
		require.ensure(
			["../school/main.js"],
			function(require) {
				try {
					const bundleExports = require("../school/main");
					onSuccess(bundleExports);
				} catch (ex) {
					onError(ex);
				}
			},
			onError,
			"school"
		);
	} else if (bundleName === "profile") {
		require.ensure(
			["../profile/main.js"],
			function(require) {
				try {
					const bundleExports = require("../profile/main");
					onSuccess(bundleExports);
				} catch (ex) {
					onError(ex);
				}
			},
			onError,
			"profile"
		);
	} else if (bundleName === "library") {
		require.ensure(
			["../library/main.js"],
			function(require) {
				try {
					const bundleExports = require("../library/main");
					onSuccess(bundleExports);
				} catch (ex) {
					onError(ex);
				}
			},
			onError,
			"library"
		);
	} else if (bundleName === "beastbuilder") {
		require.ensure(
			["../beastbuilder/main.js"],
			function(require) {
				try {
					const bundleExports = require("../beastbuilder/main");
					onSuccess(bundleExports);
				} catch (ex) {
					onError(ex);
				}
			},
			onError,
			"beastbuilder"
		);
	} else if (bundleName === "theater") {
		require.ensure(
			["../theater/main.js"],
			function(require) {
				try {
					const bundleExports = require("../theater/main");
					onSuccess(bundleExports);
				} catch (ex) {
					onError(ex);
				}
			},
			onError,
			"theater"
		);
	} else if (bundleName === "lab") {
		require.ensure(
			["../lab/main.js"],
			function(require) {
				try {
					const bundleExports = require("../lab/main");
					onSuccess(bundleExports);
				} catch (ex) {
					onError(ex);
				}
			},
			onError,
			"lab"
		);
	}
};

module.exports = loadBundle;
